import { memo } from "react";
import { useTranslation } from "react-i18next";
import Title from "@/components/Title";
import { List } from "@/components/list/List";
import { DataTableQueryContext } from "@/components/data-table/DataTableQueryContext";
import { LaborCostsEntityType } from "@/modules/projects/components/invoiceSpecifications/types/LaborCostsEntityType";
import { useInvoiceSpecificationLaborCostsList } from "../hooks/useInvoiceSpecificationLaborCostsList";
import { useInvoiceSpecificationLaborCostsQuery } from "../hooks/useInvoiceSpecificationLaborCostsQuery";

interface InvoiceSpecificationLaborCostsInStoresSectionProps {
  invoiceSpecificationId: string;
  projectDependsOn: LaborCostsEntityType;
}

const InvoiceSpecificationLaborCostsInStoresSectionComponent = ({
  invoiceSpecificationId,
  projectDependsOn,
}: InvoiceSpecificationLaborCostsInStoresSectionProps) => {
  const { t } = useTranslation();

  const { config, options, tableFeatures } =
    useInvoiceSpecificationLaborCostsList(
      invoiceSpecificationId,
      projectDependsOn,
    );

  const { query, queryValue } = useInvoiceSpecificationLaborCostsQuery(
    config,
    invoiceSpecificationId,
    options,
  );

  return (
    <List
      schema={config.schema}
      name={"laborCostsInStores"}
      query={query}
      options={options}
      tableFeatures={tableFeatures}
    >
      <div className="py-2">
        <Title>{t(`laborCostsInStores.${config.translationKey}.header`)}</Title>
      </div>
      <div>
        <List.Menubar className="mb-2 grow">
          <List.Menubar.Tools />
          <List.Menubar.Columns />
          <List.Menubar.Reset />
        </List.Menubar>
        <DataTableQueryContext.Provider value={queryValue}>
          <List.Content />
        </DataTableQueryContext.Provider>
      </div>
    </List>
  );
};

export const InvoiceSpecificationLaborCostsInStoresSection = memo(
  InvoiceSpecificationLaborCostsInStoresSectionComponent,
);
